import React, { Suspense, lazy } from 'react';
import Loader from '~components/main-loader';

const CalendarPage = lazy(() => import('./index'));

function CalendarPageLazy(props) {
    return (
        <Suspense fallback={<Loader />}>
            <CalendarPage {...props} />
        </Suspense>
    );
}

export default CalendarPageLazy;
export { CalendarPageLazy };



// WEBPACK FOOTER //
// ./src/routes/main/calendar-page/lazy.js